// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1QeSM","image":"Header_image__2hY9O","name":"Header_name__1idX3","info":"Header_info__xe5-l","infoRow":"Header_infoRow__URwRj"};